// Tabs do detalhe do cliente — Story 2.6.
// Deep link via ?tab=X (useSearchParams). 9 tabs com whitelist.

import { useSearchParams } from 'react-router-dom';

export const CLIENT_TAB_IDS = [
  'dados',
  'contatos',
  'assinaturas-owl',
  'assinaturas-direct',
  'cobrancas',
  'pagamentos',
  'comunicacoes',
  'vinculos-saas',
  'logs',
] as const;

export type ClientTabId = (typeof CLIENT_TAB_IDS)[number];

const TABS: { id: ClientTabId; label: string }[] = [
  { id: 'dados', label: 'Dados' },
  { id: 'contatos', label: 'Contatos' },
  { id: 'assinaturas-owl', label: 'Assinaturas Owl' },
  { id: 'assinaturas-direct', label: 'Assinaturas Direct' },
  { id: 'cobrancas', label: 'Cobranças' },
  { id: 'pagamentos', label: 'Pagamentos' },
  { id: 'comunicacoes', label: 'Comunicações' },
  { id: 'vinculos-saas', label: 'Vínculos SaaS' },
  { id: 'logs', label: 'Logs' },
];

/**
 * Hook controlador da tab ativa via ?tab=X.
 * Whitelist: valor inválido cai pra 'dados'.
 */
export function useActiveTab(): {
  active: ClientTabId;
  setActive: (id: ClientTabId) => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab');
  const active: ClientTabId = (CLIENT_TAB_IDS as readonly string[]).includes(raw ?? '')
    ? (raw as ClientTabId)
    : 'dados';

  function setActive(id: ClientTabId): void {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: false });
  }

  return { active, setActive };
}

export function ClientTabs(): JSX.Element {
  const { active, setActive } = useActiveTab();

  return (
    <nav
      role="tablist"
      aria-label="Seções do cliente"
      className="flex flex-wrap items-center gap-1 border-b border-line"
    >
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-controls={`tab-${tab.id}-panel`}
            id={`tab-${tab.id}`}
            onClick={() => setActive(tab.id)}
            className={`-mb-px border-b-2 px-3 py-2 text-[12px] font-medium transition-colors ${
              isActive ? 'border-ink text-ink' : 'border-transparent text-muted hover:text-ink-2'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
